import React from 'react'
import {
  BlogLogo,
  BlogNavigation,
  BlogNavigationInnerContainer,
  Tab,
  Tabs
} from './BlogTabs.styles'
import DecorBlogLogo from '../../assets/blog/DecorBlogLogo.svg'
import Link from 'next/link'

export const BlogTabs = ({ hideTitle, categories, active = null }) => {
  return (
    <BlogNavigation>
      <BlogNavigationInnerContainer>
        {!hideTitle && <h1>DecorMatters Blog</h1>}
        <Link href="/blog">
          <BlogLogo src={DecorBlogLogo} alt="DecorBlog" />
        </Link>
        <Tabs>
          <Link href="/blog" passHref>
            <Tab active={active === null}>All</Tab>
          </Link>
          {categories.map(category => (
            <Link
              key={category.id}
              href={`/blog/category/${category.attributes.slug}`}
              passHref
            >
              <Tab active={category.id === active}>
                {category.attributes.title}
              </Tab>
            </Link>
          ))}
        </Tabs>
      </BlogNavigationInnerContainer>
    </BlogNavigation>
  )
}
